import { InputConfig } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationJobPositionLocationTypeChoices } from "@graphql/generated";
import dayjs from "dayjs";

export const inputConfig = (): InputConfig[] => {
  return [
    {
      name: "title",
      previewSize: {
        sm: 12,
      },
      inputProps: {
        defaultValue: "",
        type: "text",
        label: "Job Title:",
        placeholder: "Enter Nickname / short name",
      },
      rules: {
        required: "Job Title is required",
      },
    },
    {
      name: "vaccancy",
      previewSize: {
        sm: 12,
        md: 6,
        lg: 4,
      },
      inputProps: {
        type: "number",
        label: "Number of Vacancies:",
        placeholder: "Number of Vacancies",
      },
      rules: {
        min: { value: 1, message: "Number of Vacancies must be at least 1" },
        required: "Number of Vacancies is required",
      },
    },
    {
      name: "validityDays",
      previewSize: {
        sm: 12,
        md: 6,
        lg: 4,
      },
      inputProps: {
        type: "searcher",
        label: "Ad validity date:",
        placeholder: "Ad validity date",
        labelKey: "label",
        valueKey: "value",
        items: [
          { label: "10 Days", value: "10" },
          { label: "20 Days", value: "20" },
          { label: "30 Days", value: "30" },
          { label: "45 Days", value: "45" },
          { label: "60 Days", value: "60" },
          { label: "Unlimited", value: "1000" },
        ],
      },
    },
    {
      name: "startAt",
      previewSize: {
        sm: 12,
        md: 6,
        lg: 4,
      },
      inputProps: {
        type: "date",
        label: "Start Date:",
        minDate: dayjs().startOf("day").toDate(),
      },
    },

    {
      name: "locationType",
      previewSize: {
        sm: 12,
        md: 6,
        lg: 4,
      },
      inputProps: {
        type: "searcher",
        label: "Location Type:",
        placeholder: "Location Type",
        labelKey: "label",
        valueKey: "value",
        items: [
          {
            label: "On Site (Precise Location)",
            value: AuthAccountOrganizationJobPositionLocationTypeChoices.PRECISE_LOCATION,
          },
          {
            label: "On Site (Within a Limited Area)",
            value: AuthAccountOrganizationJobPositionLocationTypeChoices.LIMITED_AREA,
          },
          { label: "Remote", value: AuthAccountOrganizationJobPositionLocationTypeChoices.REMOTE },
          { label: "Hybrid", value: AuthAccountOrganizationJobPositionLocationTypeChoices.HYBRID },
          {
            label: "On The Road",
            value: AuthAccountOrganizationJobPositionLocationTypeChoices.ON_THE_ROAD,
          },
          {
            label: "Global",
            value: AuthAccountOrganizationJobPositionLocationTypeChoices.GLOBAL,
          },
        ],
      },
      rules: {
        required: "This field is required.",
      },
    },
    {
      name: "hiringInCanada",
      previewSize: {
        sm: 12,
        md: 6,
        lg: 4,
      },
      inputProps: {
        type: "searcher",
        label: "Hiring employee from:",
        placeholder: "Hiring employee from",
        labelKey: "label",
        valueKey: "value",
        items: [
          { label: "Only Canada", value: "true" },
          { label: "Other Countries", value: "false" },
          { label: "Not Important", value: "null" },
        ],
      },
    },
    {
      name: "description",
      previewSize: {
        sm: 12,
      },
      inputProps: {
        defaultValue: "",
        type: "textarea",
        minRows: 10,
        label: "Job Description:",
        placeholder: "Enter caption /description",
      },
      rules: {
        required: "This field is required.",
      },
    },
  ];
};
